import { DatePipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NoPermissionPageModule } from '@components/no-permission/no-permission-page.module';
import { APP_CONFIG } from '@constants';
import { environment } from '@environment';
import { LottieComponent, provideLottieOptions } from 'ngx-lottie';

import { MSpinnerModule } from '@mercadona/components/spinner';
import { MAuthModule } from '@mercadona/core/auth';
import { MLoggerModule } from '@mercadona/core/logger';
import { MPlatformModule } from '@mercadona/core/platform';
import { MTelemetryModule } from '@mercadona/core/telemetry';
import { MTranslateModule } from '@mercadona/core/translate';
import { MErrorHandlerModule } from '@mercadona/core-ui/error-handler';
import { MPageErrorModule } from '@mercadona/core-ui/page-error';
import { MPageNotFoundModule } from '@mercadona/core-ui/page-not-found';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MErrorHandlerModule.forRoot(),
    MTranslateModule.forRoot(APP_CONFIG.language),
    MLoggerModule.forRoot({
      logLevel: environment.logLevel
    }),
    MPlatformModule.forRoot({
      appName: APP_CONFIG.appName,
      environment: environment.env
    }),
    MAuthModule.forRoot({
      ...environment.configToken,
      restServices: [environment.api]
    }),
    MSpinnerModule,
    MPageNotFoundModule,
    NoPermissionPageModule,
    MPageErrorModule.forRoot(),
    MTelemetryModule.forRoot({
      url: environment.telemetryConfig.url,
      traces: environment.telemetryConfig.traces
    }),
    LottieComponent
  ],
  providers: [
    DatePipe,
    provideLottieOptions({
      player: () => import('lottie-web')
    })
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
